export default {
      id: "imei-usage",
      viewBox: "0 0 15 18",
      url: __webpack_public_path__ + "img/icons.svg#imei",
      toString: function () {
        return this.url;
      }
    }